module.exports = __webpack_public_path__ + "media/images/mailer/activation_customer/load_data_de-394a0a49db16882ddfafae63c1795a92.gif";